import { render, staticRenderFns } from "./attendee-field-dialog.vue?vue&type=template&id=6176edc8&scoped=true"
import script from "./attendee-field-dialog.vue?vue&type=script&lang=js"
export * from "./attendee-field-dialog.vue?vue&type=script&lang=js"
import style0 from "./attendee-field-dialog.vue?vue&type=style&index=0&id=6176edc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6176edc8",
  null
  
)

export default component.exports